import { createContext, useState } from "react";
import API from "../api/deliveryApi"; // ✅ Import API to handle backend logout

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [deliveryBoy, setDeliveryBoy] = useState(() => {
        try {
            const storedDeliveryBoy = localStorage.getItem("deliveryBoy");
            if (!storedDeliveryBoy || storedDeliveryBoy === "undefined") {
                return null;
            }
            return JSON.parse(storedDeliveryBoy);
        } catch (error) {
            console.error("Invalid deliveryBoy data");
            return null;
        }
    });

    // ✅ Target the specific delivery access token
    const [token, setToken] = useState(
        localStorage.getItem("delivery_access_token")
    );

    const login = (data) => {
        // ✅ SAVE DUAL TOKENS
        localStorage.setItem("delivery_access_token", data.access_token);
        localStorage.setItem("delivery_refresh_token", data.refresh_token);

        // ✅ SAVE DELIVERY BOY
        localStorage.setItem("deliveryBoy", JSON.stringify(data.delivery_boy));

        // ✅ UPDATE STATE
        setToken(data.access_token);
        setDeliveryBoy(data.delivery_boy);
    };

    const logout = async () => {
        // ✅ SECURE BACKEND CLEANUP
        try {
            const currentToken = localStorage.getItem("delivery_access_token");
            if (currentToken) {
                await API.post("/auth/logout");
            }
        } catch (error) {
            console.log("Backend cleanup finished or token already expired.");
        }

        setDeliveryBoy(null);
        setToken(null);

        localStorage.removeItem("delivery_access_token");
        localStorage.removeItem("delivery_refresh_token");
        localStorage.removeItem("deliveryBoy");
        
        window.location.href = "/"; // Force redirect to login
    };

    return (
        <AuthContext.Provider
            value={{
                deliveryBoy,
                token,
                login,
                logout
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};